import { formatValue } from '@wnc/ui/src/utils';

export const useFormatValue = () => {
  return formatValue;
};
